import { FC, useState } from "react";
import { useSelector } from "react-redux";

import Modal from "components/Modal";
import { PaintBrushIcon } from "./icons";
import {
  selectDrawingCount,
  type DrawingToolName,
  type SelectedTool,
} from "../model";
import { DrawingTabs, type DrawingTab } from "./DrawingTabs";
import { AllToolsList } from "./AllToolsList";
import { CurrentToolsList } from "./CurrentToolsList";
import { DeleteAllButton } from "./DeleteAllButton";
import { ToolSettingsModal } from "./ToolSettingsModal";

import styles from "./styles/SelectDrawingTool.module.css";

export const SelectDrawingTool: FC = () => {
  const [showModal, setShowModal] = useState(false);
  const [activeTab, setActiveTab] = useState<DrawingTab>("all");
  const [selectedTool, setSelectedTool] = useState<SelectedTool | null>(null);
  const count = useSelector(selectDrawingCount);

  const handleToolClick = (
    id: string,
    name: DrawingToolName,
    label: string,
  ) => {
    setSelectedTool({ id, name, label });
  };

  const handleSettingsClose = () => {
    setSelectedTool(null);
  };

  return (
    <>
      <button
        className={`button ${styles.trigger}`}
        onClick={() => setShowModal(true)}
        title="Drawing"
      >
        <PaintBrushIcon className={styles.icon} />
        {count > 0 && <span className={styles.count}>{count}</span>}
      </button>

      <Modal
        isOpen={showModal && !selectedTool}
        onClose={() => setShowModal(false)}
        title="Drawings"
      >
        <div className={styles.content}>
          {count > 0 && (
            <DrawingTabs
              active={activeTab}
              currentCount={count}
              onChange={setActiveTab}
            />
          )}
          {activeTab === "all" || count === 0 ? (
            <AllToolsList />
          ) : (
            <CurrentToolsList onToolClick={handleToolClick} />
          )}
          {count > 0 && <DeleteAllButton count={count} />}
        </div>
      </Modal>

      {showModal && selectedTool && (
        <ToolSettingsModal
          instanceId={selectedTool.id}
          toolName={selectedTool.name}
          toolLabel={selectedTool.label}
          onClose={handleSettingsClose}
        />
      )}
    </>
  );
};
